var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-cart",attrs:{"id":"moveDiv"},on:{"click":_vm.handleGoCart,"mousedown":_vm.down,"touchstart":_vm.down,"mousemove":_vm.move,"touchmove":function($event){$event.preventDefault();return _vm.move.apply(null, arguments)},"mouseup":_vm.end,"touchend":_vm.end}},[_c('van-icon',{attrs:{"name":"cart-o","info":_vm.count}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }